var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.fields)?_c('main',{class:_vm.$style.view},[_c('div',{class:_vm.$style.cover},[_c('div',{class:_vm.$style.image},[(_vm.coverImage)?_c('base-image',{attrs:{"image":_vm.coverImage,"sizes":_vm.sizes}}):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }